/**
 * Janken SFX registry — registered in soundConfig.ts via spread.
 *
 * SFX map (where each sound is used):
 *
 * Custom janken sounds:
 *   jankenWin   — Result reveal: win outcome (PopupJanken: applyJankenSpineResult, showResultSkipped)
 *   jankenLose  — Result reveal: lose outcome (PopupJanken: applyJankenSpineResult, showResultSkipped)
 *   jankenDraw  — Result reveal: draw outcome (PopupJanken: applyJankenSpineResult, showResultSkipped)
 *
 * Reused existing sounds:
 *   ok          — START/REVEAL tap, Challenge Friends tap, info button, care button, claim (PopupJanken, PopupJankenReward)
 *   cancel      — Close (x) button (PopupJanken)
 *   progressCounted — Countdown SFX ticks (PopupJanken: playCountdownSfx)
 *   puzzle-ice-tap — Info popup step reveals (PopupJankenInfo: showAnimated)
 *   tada        — Reward popup open (PopupJankenReward: animateIn)
 *   applause    — Reward popup open (PopupJankenReward: animateIn)
 */
export const jankenSfx = {
  jankenWin: {
    volume: 1,
    background: false,
    sources: ['janken/janken_win.mp3'],
  },
  jankenLose: {
    volume: 1,
    background: false,
    sources: ['janken/janken_lose.mp3'],
  },
  jankenDraw: {
    volume: 1,
    background: false,
    sources: ['janken/janken_draw.mp3'],
  },
};
